import React, { useCallback, useEffect, useState } from "react";
import { Sun, ChevronDown, ChevronUp, Plus, Loader2 } from "lucide-react";
import { api } from "../../lib/api";
import { ProgettoFVEditor } from "../../pages/Progetto3DEditor";

const fmt = (iso) => (iso ? new Date(iso).toLocaleString("it-IT", { day: "2-digit", month: "2-digit", year: "numeric", hour: "2-digit", minute: "2-digit" }) : "");

export const SopralluogoProgettoFV = ({ cliente, onChanged }) => {
  const [project, setProject] = useState(undefined);
  const [open, setOpen] = useState(false);

  const load = useCallback(() => {
    api.get("/solar/projects", { params: { cliente_id: cliente.id } })
      .then(({ data }) => setProject(data[0] || null)).catch(() => setProject(null));
  }, [cliente.id]);
  useEffect(() => { load(); }, [load]);

  const nome = `${cliente.nome || ""} ${cliente.cognome_ragione_sociale || ""}`.trim();
  const address = [cliente.indirizzo, [cliente.cap, cliente.citta].filter(Boolean).join(" "), cliente.provincia].filter(Boolean).join(", ");
  const onSaved = (_id, sent) => { load(); if (sent) onChanged?.(); };
  const kwp = project?.config?.kwp;

  return (
    <div className="card-shell overflow-hidden" data-testid="sopralluogo-progetto-fv">
      <div className="p-4 flex flex-wrap items-center gap-3">
        <Sun className="w-5 h-5" style={{ color: "#E8A100" }} />
        <div className="flex-1 min-w-[180px]">
          <div className="font-bold" style={{ fontFamily: "Manrope" }}>Progetto FV</div>
          <div className="text-xs" style={{ color: "var(--text-muted)" }} data-testid="sopralluogo-fv-status">
            {project === undefined ? "Caricamento…" : project
              ? `${project.name}${kwp ? ` · ${kwp} kWp` : ""} · aggiornato ${fmt(project.updated_at)}${project.sopralluogo_sent_at ? ` · inserito nel sopralluogo ${fmt(project.sopralluogo_sent_at)}` : ""}`
              : `Nessun progetto. Si parte da ${cliente.coord_lat != null ? "coordinate" : "indirizzo"} della scheda cliente.`}
          </div>
        </div>
        <button onClick={() => setOpen((o) => !o)} disabled={project === undefined} className={open ? "btn-secondary" : "btn-primary"} data-testid="sopralluogo-fv-toggle">
          {project === undefined ? <Loader2 className="w-4 h-4 animate-spin" /> : open ? <ChevronUp className="w-4 h-4" /> : project ? <ChevronDown className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
          {open ? "Chiudi editor" : project ? "Apri progetto FV" : "Crea progetto FV"}
        </button>
      </div>
      {open && (
        <div className="p-3 md:p-4 border-t" style={{ borderColor: "var(--border)" }} data-testid="sopralluogo-fv-editor">
          <ProgettoFVEditor
            embedded
            pid={project?.id || null}
            clienteId={cliente.id}
            initialName={`FV ${nome}`.trim()}
            initialAddress={address}
            initialLat={cliente.coord_lat ?? null}
            initialLng={cliente.coord_lng ?? null}
            onSaved={onSaved}
          />
        </div>
      )}
    </div>
  );
};
